import EnumSortItem from "../../../../utils/enum/EnumSortItem";

const optionsSortBy = [
  { id: EnumSortItem.TIME, label: "Time" },
  { id: EnumSortItem.VOTE, label: "Votes" },
  { id: EnumSortItem.NUM_OF_DISCUSSIONS, label: "Num of discussions" },
];

export { optionsSortBy };
